module.exports = __webpack_public_path__ + "site/img/41.ea0009cf.jpg";